import React, { useState, useEffect } from 'react'
import { buildPropTypes, pt } from 'common-data/proptypehelpers'
import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

export class TabBoxItem extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    children: pt.any,
    title: pt.string.isRequired,
    tabId: pt.string,
    showCloseIcon: pt.bool.isRequired,
    onCloseTab: pt.func,
    onTabChanged: pt.func
  })

  static defaultProps = {
    title: 'Some Tab',
    showCloseIcon: false
  }

  render () {
    const { children } = this.props
    return children
  }
}

export function TabBox (props) {
  const { defaultTabId = '1', children, testId, onTabChanged } = props

  const [activeTab, setActiveTab] = useState(defaultTabId)

  useEffect(() => {
    setActiveTab(defaultTabId)
  }, [defaultTabId])

  const [tabMaps, setTabMaps] = useState([])

  useEffect(() => {
    const maps = {
      navs: [],
      tabs: []
    }
    if (_.isArray(children)) {
      _.forEach(children, (item, i) => {
        if (item) {
          if (item.type === TabBoxItem) {
            maps.navs.push(
              <li data-tid={`${testId}-${item.props.tabId}-nav`} key={item.props.tabId} className={clsx('tabs-title', activeTab === item.props.tabId && 'is-active')}>
                <a href="#" onClick={toggle(item.props.tabId)} aria-selected={activeTab === item.props.tabId ? 'true' : undefined}>{item.props.title}</a>
              </li>
            )
            maps.tabs.push(
              <div data-tid={`${testId}-${item.props.tabId}-tab`} key={item.props.tabId} className={clsx('tabs-panel', activeTab === item.props.tabId && 'is-active')}>
                {item.props.children}
              </div>
            )
          }
        }
      })
    }
    setTabMaps(maps)
  }, [activeTab, children])

  const toggle = (tab) => (e) => {
    console.log('Clicking Tab')
    console.log(tab)
    if (activeTab !== tab) {
      setActiveTab(tab)
      if (_.isFunction(onTabChanged)) {
        onTabChanged(tab)
      }
    }
  }

  // function onCloseTab (tabId) {
  //   const { onCloseTab, onTabChanged } = this.props
  //   const { tabs } = this
  //   if (_.isFunction(onCloseTab)) {
  //     let newActiveTabId = onCloseTab(tabId)
  //     if (!newActiveTabId) {
  //       newActiveTabId = _.first(tabs)
  //     }

  //     if (newActiveTabId) {
  //       this.setState({
  //         activeTab: newActiveTabId
  //       }, () => {
  //         if (_.isFunction(onTabChanged)) {
  //           onTabChanged(newActiveTabId)
  //         }
  //       })
  //     }
  //   }
  // }

  return <>
    <ul className='tabs'>
      {tabMaps.navs}
    </ul>
    <div className='tabs-content'>
      {tabMaps.tabs}
    </div>
  </>
}
